import { AST } from 'node-sql-parser';
import type { ASTNode } from './SqlToFilterConverter.utils';

// eslint-disable-next-line fabric-ui/no-class
export class SqlParserError extends Error {
  constructor(
    message: string,
    public context?: { node?: ASTNode; sql?: string; ast?: AST } & ErrorOptions
  ) {
    super(message, { cause: context?.cause });
    this.name = 'SqlParserError';
  }
}

export const isSqlParserError = (error: unknown): error is SqlParserError =>
  error instanceof SqlParserError && error.name === 'SqlParserError';
